import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PostEntries } from 'src/app/store/application';

@Injectable()
export class StatService {
    userUrl = 'api/stat';

    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
    };

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    getStatHolidays(): Observable<any> {
        return this.httpClient.get(this.userUrl, this.httpOptions);
    }

}
